import React, { ReactNode } from 'react';
import { ButtonColors, JRCButton } from '../JRCButton/JRCButton';
import {
    JRCModalBody,
    JRCModalClose,
    JRCModalContentFull,
    JRCModalFooter,
    JRCModalHeader,
    JRCModalOptions,
    JRCModalTitle,
} from './JRCModal.styles';
import { JRCH3 } from '../JRCTypo/JRCTypo';
import { JRCIconButton } from '../JRCIconButton/JRCIconButton';
import styled from 'styled-components';

const Container = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;

export type JRCModalContentBase = {
    title?: ReactNode;
    children?: ReactNode;
    options?: ReactNode;
    overflow?: 'visible' | 'hidden' | 'scroll';
    onClickIconClose?: () => void;
    dataCy?: string;
};

export type JRCModalContentProps = JRCModalContentBase & {
    isFull?: boolean;
    buttons?: JRCModalButtonType[];
};

export interface JRCModalButtonType {
    children: ReactNode;
    color?: ButtonColors;
    variant?: 'contained' | 'outlined';
    clickHandler?: () => void;
    dataCy?: string;
    disabled?: boolean;
    loading?: boolean;
}

export const ModalOptions = ({ children }: { children?: React.ReactNode }) => {
    return children ? <JRCModalOptions>{children}</JRCModalOptions> : <></>;
};
export const ModalTitle = ({ children }: { children?: React.ReactNode }) => {
    return children ? (
        <JRCModalTitle>
            <JRCH3>{children}</JRCH3>
        </JRCModalTitle>
    ) : (
        <></>
    );
};

export const JRCModalContent = ({
    title,
    onClickIconClose,
    overflow,
    options,
    children,
    buttons,
    isFull,
    dataCy,
}: JRCModalContentProps) => {
    return (
        <Container data-cy={dataCy}>
            {(title || onClickIconClose) && (
                <JRCModalHeader className={'modal-header'} modalOverflow={overflow}>
                    <ModalTitle>{title}</ModalTitle>
                    <ModalOptions>{options}</ModalOptions>
                    {onClickIconClose && (
                        <JRCModalClose>
                            <JRCIconButton icon="icon-times" color={'grey5'} onClick={onClickIconClose} />
                        </JRCModalClose>
                    )}
                </JRCModalHeader>
            )}
            {isFull ? (
                <JRCModalContentFull className="modal-content">{children}</JRCModalContentFull>
            ) : (
                <JRCModalBody className="modal-content" modalOverflow={overflow}>
                    {children}
                </JRCModalBody>
            )}
            {buttons && (
                <JRCModalFooter modalOverflow={overflow}>
                    {buttons.map((button: JRCModalButtonType, index: number) => (
                        <JRCButton
                            key={index}
                            color={button.color}
                            variant={button.variant}
                            onClick={button.clickHandler}
                            dataCy={button.dataCy}
                            disabled={button.disabled}
                            loader={button.loading}>
                            {button.children}
                        </JRCButton>
                    ))}
                </JRCModalFooter>
            )}
        </Container>
    );
};
